export default "__VITE_ASSET__4601139f__"